import type {
  CreateProcedureCategory,
  ProcedureCategory,
  UpdateProcedureCategory,
} from "@dentacore/shared-types";

import { api } from "./client";

/**
 * The clinic's procedure categories — STORY-176a (PG-D1, PG-D2). One list for
 * the whole clinic; the branch header goes with every call as usual and the
 * server does not read it. Reading is open to anyone who can see procedures —
 * the booking form and the calendar's key need it; every write needs
 * `procedures.manage`, and the server refuses anyone else.
 */
export function listProcedureCategories(signal?: AbortSignal): Promise<ProcedureCategory[]> {
  return api<ProcedureCategory[]>("/procedure-categories", { branchScoped: true, signal });
}

export function createProcedureCategory(body: CreateProcedureCategory): Promise<ProcedureCategory> {
  return api<ProcedureCategory>("/procedure-categories", {
    method: "POST",
    body,
    branchScoped: true,
  });
}

export function updateProcedureCategory(
  id: string,
  body: UpdateProcedureCategory,
): Promise<ProcedureCategory> {
  return api<ProcedureCategory>(`/procedure-categories/${id}`, {
    method: "PATCH",
    body,
    branchScoped: true,
  });
}

/** Refused while any procedure uses it (PG-D5); the message says how many. */
export function removeProcedureCategory(id: string): Promise<void> {
  return api<void>(`/procedure-categories/${id}`, { method: "DELETE", branchScoped: true });
}

/** Every category's id, once, in the new order. */
export function orderProcedureCategories(ids: readonly string[]): Promise<ProcedureCategory[]> {
  return api<ProcedureCategory[]>("/procedure-categories/order", {
    method: "PUT",
    body: { ids },
    branchScoped: true,
  });
}
